import { OnboardingFormActions } from '../../../enums'
import { RemoveCompanyAction } from '../../../types/actions'

export const removeCompany = ({ companyIndex }: { companyIndex: number }): RemoveCompanyAction => ({
  type: OnboardingFormActions.REMOVE_COMPANY,
  payload: {
    companyIndex
  }
})
